import React, { useEffect, useState, useRef } from 'react';
import { useMediaQuery, useTheme } from '@mui/material';
import { connect } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import Slider from "react-slick";

import Billing from './Components/Billing';
import Profile from './Components/Profile';
import Subscription from './Components/Subscription';
import SubscriptionPromo from './Components/SubscriptionPromo';
import CustomTab from '../../common/CustomTab';

import { LoadUserData, LoadUserBillingData, CheckRequirementsAndRedirectV2 } from "../../redux/v2/user/actions";

import "./style.css"
import CustomSlider from '../../common/CustomSlider';
import CancelV2 from './Components/CancelV2';

function Account(props) {
    const location = useLocation();
    const navigate = useNavigate();
    const requirementStatus = localStorage.getItem("requirement_status");
    const sliderRef = useRef(null);
    const [showSlider, setShowSlider] = useState(false);

    const [page, setPage] = useState(0);
    const { user, billing, account } = props.User;
    const { state } = location;

    const theme = useTheme()
    const smallView = useMediaQuery(theme.breakpoints.down('md'))

    const PROFILE = {
        label: "PROFILE",
        active: state?.selectedComponent === "PROFILE" ? true : (!state?.hasOwnProperty("selectedComponent") ? true : false),
    };
    const BILLING = {
        label: "BILLING",
        active: state?.selectedComponent === "BILLING" ? true : false,
    };
    const SUBSCRIPTION = {
        label: "SUBSCRIPTION",
        active: state?.selectedComponent === "SUBSCRIPTION" ? true : false,
    };

    useEffect(() => {
        props.CheckRequirementsAndRedirectV2(navigate);
        // if (requirementStatus == 3 || requirementStatus == "null") {
        //     props.LoadUserData();
        // }
    }, []);

    useEffect(() => {
        if ((requirementStatus == 3 || requirementStatus == "null") && account?.user?.id) {
            if (!account?.user?.company) {
                props.LoadUserBillingData();
            }
        }
    }, [account?.user?.id]);

    const inPromo = (account?.billingInfo?.currentPlan?.code == "promo" && !account?.billingInfo?.pendingChange?.plan?.code);
    const [togglers, setTogglers] = useState(
        !account?.user?.company
            ? inPromo
                ? [
                    PROFILE,
                    SUBSCRIPTION,
                ]
                : [
                    PROFILE,
                    BILLING,
                    SUBSCRIPTION,
                ]
            : [
                PROFILE,
                BILLING,
            ]);
    const [contents, setContents] = useState(
        !account?.user?.company
            ? inPromo
                ? [
                    "PROFILE",
                    "SUBSCRIPTION",
                ]
                : [
                    "PROFILE",
                    "BILLING",
                    "SUBSCRIPTION",
                ]
            : [
                "PROFILE",
                "BILLING",
            ]);

    const [selectedComponent, setSelectedComponent] = useState(state?.selectedComponent ? state?.selectedComponent : togglers[0].label);

    useEffect(() => {
        setTogglers(
            !account?.user?.company
                ? inPromo
                    ? [
                        PROFILE,
                        SUBSCRIPTION,
                    ]
                    : [
                        PROFILE,
                        BILLING,
                        SUBSCRIPTION,
                    ]
                : [
                    PROFILE,
                    BILLING,
                ]
        )
        setContents(
            !account?.user?.company
                ? inPromo
                    ? [
                        "PROFILE",
                        "SUBSCRIPTION",
                    ]
                    : [
                        "PROFILE",
                        "BILLING",
                        "SUBSCRIPTION",
                    ]
                : [
                    "PROFILE",
                    "BILLING",
                ]
        )

        setSelectedComponent(state?.selectedComponent ? state?.selectedComponent : selectedComponent)
    }, [state?.selectedComponent, account?.user, account?.billingInfo]);

    useEffect(() => {
        sliderRef?.current?.slickGoTo(contents.indexOf(state?.selectedComponent));
    }, [contents]);

    useEffect(() => {
        sliderRef?.current?.slickGoTo(contents.indexOf(selectedComponent));
    }, [selectedComponent]);

    useEffect(() => {
        sliderRef?.current?.slickGoTo(page);
    }, [page]);

    const settings = {
        rows: 1,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        swipeToSlide: true,
        swipe: false,
        arrows: false,
        draggable: false,
        initialSlide: page,
        adaptiveHeight: true,
    };

    return (
        <>
            <div
                className="container-v2"
                id="my-account-component"
                style={{ paddingTop: '30px' }}
            >
                <div className='wrapper-v2'>
                    <div className='header-v2 row'>

                        <div className='row'>
                            <div className='col-md-12 flex-c'>
                                {!smallView && (
                                    <h4>MY ACCOUNT</h4>
                                )}
                            </div>
                            <div className='component-toggler-wrapper col-md-12 flex-c'>
                                <div className='component-togglers flex-c' style={{ margin: smallView ? 'auto' : '', display: "flex" }}>
                                    <CustomTab tabs={togglers} onClick={(label, i) => {

                                        sliderRef?.current?.slickGoTo(i);
                                        setTogglers(tglrs => togglers.map((tog, i2) => {
                                            return {
                                                ...tog,
                                                active: label == tog.label
                                            }
                                        }))

                                        setSelectedComponent(label);
                                    }} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='content-v2-wrapper'>
                        <div className='content-v2'>
                            <Slider {...settings} ref={sliderRef}>

                                {
                                    contents.includes("PROFILE") &&
                                    <div>
                                        <Profile />
                                    </div>
                                }

                                {
                                    contents.includes("BILLING") &&
                                    <div>
                                        <Billing />
                                    </div>
                                }

                                {
                                    contents.includes("SUBSCRIPTION") &&
                                    <div>
                                        {
                                            inPromo
                                                ? <SubscriptionPromo />
                                                : <Subscription showSlider={showSlider} setShowSlider={setShowSlider} />
                                        }
                                    </div>
                                }

                            </Slider>

                        </div>
                    </div>

                </div>
            </div>

            <CustomSlider show={showSlider} setShowSlider={setShowSlider}>
                <CancelV2 />
            </CustomSlider>
        </>
    );
}

const mapStateToProps = (state) => ({
    User: state.User,
})

export default connect(mapStateToProps, {
    LoadUserData,
    LoadUserBillingData,
    CheckRequirementsAndRedirectV2,
})(Account);
